import { useCallback, type Dispatch } from "react";
import type { CreationState, CreationAction } from "../state/creationState";

export interface CreationStepNavigationHandlers {
  handleBackToGoals: () => void;
  handleEditFromReview: () => void;
  handleReturnToReview: () => void;
}

export function useCreationStepNavigation(
  state: CreationState,
  dispatch: Dispatch<CreationAction>,
): CreationStepNavigationHandlers {
  const handleBackToGoals = useCallback(() => {
    dispatch({ type: "CLEAR_GOAL" });
  }, [dispatch]);

  const handleEditFromReview = useCallback(() => {
    dispatch({ type: "SET_RETURN_TO_STEP", payload: 3 });
    dispatch({ type: "SET_STEP", payload: 2 });
  }, [dispatch]);

  const handleReturnToReview = useCallback(() => {
    if (state.returnToStep) {
      dispatch({ type: "SET_STEP", payload: state.returnToStep });
      dispatch({ type: "SET_RETURN_TO_STEP", payload: null });
      dispatch({ type: "SET_INITIAL_MESSAGE", payload: null });
    }
  }, [state.returnToStep, dispatch]);

  return {
    handleBackToGoals,
    handleEditFromReview,
    handleReturnToReview,
  };
}
